import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import type { Promo } from '../../types'
import ActionTypes from './actionTypes'

type FetchPromoTypesRequest = {
    type: typeof ActionTypes.PROMO_TYPES_FETCH_REQUEST;
    payload: never;
}

type FetchPromoTypesFailure = {
    type: typeof ActionTypes.PROMO_TYPES_FETCH_FAILURE;
    payload: Error;
}

type FetchPromoTypesSuccess = {
    type: typeof ActionTypes.PROMO_TYPES_FETCH_SUCCESS;
    payload: { type: string }[];
}

/**
 * Fetch promo types
 */
function fetchPromoTypes() {
    return createAction<RootState, Promo[], never>({
        endpoint: `${HUBBLE_API_TOKEN}/promo-types`,
        method: 'GET',
        types: [
            ActionTypes.PROMO_TYPES_FETCH_REQUEST,
            ActionTypes.PROMO_TYPES_FETCH_SUCCESS,
            ActionTypes.PROMO_TYPES_FETCH_FAILURE,
        ],
    })
}

export type FetchPromoTypesAction = FetchPromoTypesRequest
    | FetchPromoTypesFailure
    | FetchPromoTypesSuccess

export default fetchPromoTypes
